module.exports = __webpack_public_path__ + "media/images/building-in-maintenance-e147ca745ad0b1a7f3ae07124a28ee44.svg";